import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';

import { NavBar } from "./components/NavBar";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { Home } from './components/pages/Home';
import { About } from './components/pages/About';
import { Footer } from './components/Footer';
import { Career } from './components/pages/Career';
import { OnDemand } from './components/pages/OnDemand';
import { Contact } from './components/pages/Contact';
import { MobileDevelopment } from './components/ServiceDetail/MobileDevelopment';
import { BlogDetail } from './components/BlogDetail/BlogDetail';
import { CareerForm } from './components/pages/CareerForm';
import { ScroolToTop } from './components/ScroolToTop';
import { useEffect, useRef, useState } from 'react';
import { WebDevelopment } from './components/ServiceDetail/WebDevelopment';
import { EcommerceDevelopment } from './components/ServiceDetail/EcommerceDevelopment';
import { Cybersecurity } from './components/ServiceDetail/Cybersecurity';
import { SAASDevelopment } from './components/ServiceDetail/SAASDevelopment';
import { ItInfrastructure } from './components/ServiceDetail/ItInfrastructure';
import { InformationDatabaseSecurity } from './components/ServiceDetail/InformationDatabaseSecurity';
import { ArtificialIntelligence } from './components/ServiceDetail/ArtificialIntelligence';
import { BusinessSolutions } from './components/ServiceDetail/BusinessSolutions';
import BlogWarehouse from './components/BlogDetail/BlogWarehouse';
import BlogGrowth from './components/BlogDetail/BlogGrowth';
import { UIUXDetail } from './components/CareerDetail/UIUXDetail';
import FrontEndDetail from './components/CareerDetail/FrontEndDetail';
import BackEndDetail from './components/CareerDetail/BackEndDetail';
import SaasDetail from './components/CareerDetail/SaasDetail';
import DevelopBlogList from './components/pages/blogList/DevelopBlogList';
import TechBlogList from './components/pages/blogList/TechBlogList';
import HtmlBlogList from './components/pages/blogList/HtmlBlogList';
import BrandBlogList from './components/pages/blogList/BrandBlogList';
import PhpBlogList from './components/pages/blogList/PhpBlogList';
import NoBlog from './components/BlogDetail/NoBlog';
import AndroidDetail from './components/CareerDetail/AndroidDetail';
import BlogSoft from './components/BlogDetail/BlogSoft';



const TITLES = {
  '/': 'IMUII - Home',
  '/about': 'IMUII - About',
  '/career': 'IMUII - Career',
  '/career-form': 'IMUII - Career Form',
  '/on-demand-developers': 'IMUII - On Demand Developers',
  '/contact': 'IMUII - Contact',
  '/web-development': 'IMUII - Web Development',
  '/eCommerce-development': 'IMUII - Ecommerce Development',
  '/mobile-application-development': 'IMUII - Mobile App Development',
  '/saas-development': 'IMUII - SAAS Development',
  '/cybersecurity': 'IMUII - Cybersecurity',
  '/it-infrastructure': 'IMUII - IT Infrastructure',
  '/information-database-security': 'IMUII - Information Database Security',
  '/artificial-intelligence': 'IMUII - Artificial Intelligence',
  '/end-to-end': 'IMUII - End-to-End Business Solutions',
  '/frontEndDetail': 'IMUII - Front End Developer',
  '/saasDetail': 'IMUII - Saas Developer',
  '/UIUXDetail': 'IMUII - UI / UX Designer',
  '/backEndDetail': 'IMUII - Back End Developer',
  '/androidDetail': 'IMUII - Android Developer',
  '/blog-warehouse': 'IMUII - Blog',
  '/blog-growth': 'IMUII - Blog',
  '/blog-detail': 'IMUII - Blog',
  '/noBlog': 'IMUII - Blog',
};


function App() {

  // Website Tab Title Change Function
  const { pathname } = useLocation();
  useEffect(() => {
    document.title = TITLES[pathname] || 'IMUII Web';
  }, [pathname]);

  // Scroll Bottom Hide NavBar
  const elementRef = useRef();
  const [isVisible, setIsVisible] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
            // Reset navbar visible on resize to small
            if (window.innerWidth < 992) {
                setIsVisible(false);
            }
        };

        const handleScroll = () => {
            if (windowWidth < 992) return;  // skip below 992px

            if (elementRef.current) {
                const rect = elementRef.current.getBoundingClientRect();
                const visible = (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight + 665)
                );
                setIsVisible(visible);
            }
        };

        window.addEventListener('resize', handleResize);
        window.addEventListener('scroll', handleScroll, { passive: true });
        handleScroll(); // initial check

        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('scroll', handleScroll);
        };
    }, [windowWidth]);


  // Pre Loader
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);
  
  return (
    <>

      {
        loading ? (
          <div className="preloader-jackhammer">
            <ul className="cssload-flex-container">
              <li>
                <span className="cssload-loading"></span>
              </li>
            </ul>
          </div>
        ) : (

        <>
          <ScroolToTop />
          <NavBar navVisible={isVisible} windowWidth={windowWidth} /> 

          <Routes>
            <Route path="/" exact element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/career" element={<Career />} />

            <Route path="/UIUXDetail" element={<UIUXDetail />} />
            <Route path="/frontEndDetail" element={<FrontEndDetail />} />
            <Route path="/backEndDetail" element={<BackEndDetail />} />
            <Route path="/saasDetail" element={<SaasDetail />} />
            <Route path="/androidDetail" element={<AndroidDetail />} />

            <Route path="/on-demand-developers" element={<OnDemand />} />
            <Route path="/contact" element={<Contact />} />
            
            <Route path="/web-development" element={<WebDevelopment />} />
            <Route path="/eCommerce-development" element={<EcommerceDevelopment />} />
            <Route path="/mobile-application-development" element={<MobileDevelopment />} />
            <Route path="/cybersecurity" element={<Cybersecurity />} />
            <Route path="/saas-development" element={<SAASDevelopment />} />
            <Route path="/it-infrastructure" element={<ItInfrastructure />} />
            <Route path="/information-database-security" element={<InformationDatabaseSecurity />} />
            <Route path="/artificial-intelligence" element={<ArtificialIntelligence />} />
            <Route path="/end-to-end" element={<BusinessSolutions />} />

            <Route path="/DevelopBlogList" element={<DevelopBlogList />} />
            <Route path="/TechBlogList" element={<TechBlogList />} />
            <Route path="/HtmlBlogList" element={<HtmlBlogList />} />
            <Route path="/BrandBlogList" element={<BrandBlogList />} />
            <Route path="/PhpBlogList" element={<PhpBlogList />} />

            <Route path="/blog-detail" element={<BlogDetail />} />
            <Route path="/blog-warehouse" element={<BlogWarehouse />} />
            <Route path="/blog-growth" element={<BlogGrowth />} />
            <Route path="/blog-soft" element={<BlogSoft />} />

            <Route path="/noBlog" element={<NoBlog />} />

            <Route path="/career-form" element={<CareerForm />} />
          </Routes>

          <Footer navhide={elementRef}/>
        </>
      )}
      
    </>
  );
}

export default App;
